export default "__VITE_ASSET__CEZu7rdY__"